<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :bodyStyle="bodyStyle"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :footer="null"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: (disableSubmit)} }"
    cancelText="关闭">
    <a-card title="附件信息" :bordered="false" >
        <span v-for="(item,i) in folderDefine" :key="i" v-if="!disableSubmit">
          <span style="color: red;" v-show='item.isNeed == 1'>*</span>
          <a-upload
            name="file"
            :multiple="true"
            :action="uploadAction"
            :headers="tokenHeader"
            :data="item"
            :accept="item.accept == null? '*':item.accept"
            :showUploadList="false"
            :beforeUpload="beforeFileUpload"
            :remove="handleFileRemove"
            @change="handleFileChange">
            <a-button  style="margin-right:8px;position: relative" >
              <a-icon type="upload"/>
              {{item.typeZh}}
            </a-button>

          </a-upload>
        </span>
      <a-table
        ref="filetable"
        size="middle"
        bordered
        :rowKey="(record,index)=>{return index}"
        :columns="columnsFile"
        :dataSource="modal.fileList"
        :loading="loading"
        :pagination="false"
        @change="handleTableChange"
        style="margin-top:5px;height: 190px"
      >

        <span slot="action" slot-scope="text, record,index">
          <a @click="handleDownload(record)">下载</a>
          <a-divider type="vertical"/>
          <a @click="deleteFile(index)" v-if="!disableSubmit">删除</a>
        </span>

      </a-table>
    </a-card>
    <div class="ant-modal-footer">
      <div>
        <a-button :loading="confirmLoading"  class="ant-btn" @click="beforeStep"><span>上一步</span></a-button>
        <a-button v-if="!disableSubmit" :loading="confirmLoading" style="background: #FA8200;border:0px;color: #FFFFFF" type="primary"
                  class="ant-btn ant-btn-primary" @click="handleOk"><span>提交</span></a-button>
        <a-button class="ant-btn" @click="handleCancel"><span>取消</span></a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import moment from "moment/moment";
import {downloadFile, getAction, postAction} from "@api/manage";
import {FzisListMixin} from "@/mixins/FzisListMixin";
import ProjectLandAddLandModal from "@views/earthmine/modules/ProjectLandAddLandModal.vue";
import pick from "lodash.pick";

export default {
  name: "SubjectStep5Modal",
  components: {ProjectLandAddLandModal},
  mixins:[FzisListMixin],
  data () {
    return {
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      title: "操作",
      bodyStyle:{
        padding: "0",
        overflow:"auto",
        // height:(window.innerHeight-100)+"px"
        height:"400px"
      },
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      id:"",
      fileList:[],
      jeditor:{
        value:""
      },
      url: {
        addOrUpdate: "/ebid-ce/propertyright/prSubjectTransfer/addOrUpdate",
        minioDownload: "/ebid-ce/file/minioDownload",
      },
      folderDefine:[{typeZh:'标的申请',isNeed:'1',accept:'.jpg,.png,.pdf',type:'prSubjecrApply',fp:12}],
      modal:{},
      columnsFile:[{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: "center",
        customRender: function (t, r, index) {
          return parseInt(index) + 1;
        }
      },
        {
          title: '文件名称',
          align: "center",
          dataIndex: 'fileName'
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'typeZh'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }]
    }
  },
  computed: {
    uploadAction() {
      return window._CONFIG['domianURL'] + '/ebid-ce/file/onlyUpload'
    },
  },
  methods:{
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      //this.$emit('beforeStep','4',this.modal);
      this.visible = false;
    },
    //编辑
    edit(record)
    {
      this.visible = true;
      this.modal=record;
      this.id=record.id;
      this.getfileList();
    },
    beforeStep()
    {
      this.modal.disableSubmit=this.disableSubmit;
      this.$emit('beforeStep','4',this.modal);
    },
    //获取附件
    getfileList()
    {
      console.log("this.modalthis.modal",this.modal)
      const that=this;
      this.$nextTick(() => {
        getAction('/ebid-ce/propertyright/prSubjectTransfer/file/list', { id: this.id }).then(res => {
          if (res.success) {
            that.modal.fileList=res.result;
            that.$forceUpdate()
          }
        })
      });
    } ,
    //保存
    handleOk(){
      const that = this;
      that.confirmLoading=true;
      that.$confirm({
        title: '提示',
        content: '是否确认提交?',
        onOk() {
          let formData = that.modal;
          formData.isSubmit = "1";
          postAction(that.url.addOrUpdate, formData).then(res => {
            if (res.success) {
              formData.id = res.result;
              that.visible = false;
              that.$emit('loadData');
              return;
            } else {
              that.$message.error(res.message);
            }
          }).finally(() => {
              that.confirmLoading = false
            })
        },
        onCancel() {
          that.confirmLoading=false;
        }
      })
    },
    beforeFileUpload(file) {
      //限制文件大小
      const isLt = file.size / 1024 / 1024 < 100
      if (!isLt) {
        this.$message.error('上传的文件大小不能超过100M')
        return false
      }
      this.fileList.push(file);
      return true
    },
    handleFileRemove(file)
    {
      if(file.response && this.fileList!=null)
      {
        this.modal.fileList=this.modal.fileList.filter(item => item != file.response.result);
      }
      this.$forceUpdate()
    },
    handleFileChange(info) {
      //console.log("chg",info);
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.fileUploadOk(info.file.response)
        } else {
          for (let i = 0; i < info.fileList.length; i++) {
            if (info.file.uid == info.fileList[i].uid) {
              info.fileList[i].status = 'error'
              break
            }
          }
          this.fileUploadFail(info.file.response)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    fileUploadOk(response) {
      if(this.modal.fileList==null)
      {
        this.modal.fileList=[];
      }
      this.modal.fileList.push(response.result);
      this.$forceUpdate();
    },
    fileUploadFail(response) {
      this.$message.error(response.message)
    },
    deleteFile(index) {
      const that = this;
      this.modal.fileList.splice(index,1)
      console.log("this.modal.fileList",this.modal.fileList);
      console.log(" this.fileList", this.fileList)
      // this.modal.fileList = this.modal.fileList.filter(item => item.id != fileId);
      // this.fileList = this.fileList.filter(item => item.id != fileId);
      this.$forceUpdate()
    },
    handleDownload(rec) {
      var that = this;
      getAction(that.url.minioDownload,{id: rec.id}).then(res => {
        if(res.success) {
          console.log(res.result);
          downloadFile(res.result , rec.fileName);
        }
      })
    },
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>